import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import usePaginator from "../../../theme/Component/usePaginator";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { Modal } from "../../../theme/Component/Modal";
import { _DocumentsForProjectData } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { ProjectDataDocumentsType } from "./ProjectDataDocumentsType/ProjectDataDocumentsType";
import { _DocumentFactory, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";


interface Props {
    tableName: number;
    idProject: any;
    documentsTable?: any
}

export const DocumentsForProjectData = ({ tableName, idProject, documentsTable }: Props) => {

    const getinfo = useDataBean(_DocumentsForProjectData);
    const single = Singleton.getInstance();
    const [Account, setAccount] = useState<any>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [IDProject, setIDProject] = useState<any>(null)
    const [mnemonic, setmnemonic] = useState<any>(null)
    const [consecutive, setconsecutive] = useState<any>(null)
    const [docs, setDocs] = useState<any>([]);
    const [docsob, setDocsob] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [lista, setLista] = useState<any>([]);
    const [modalobligacion, setModalobligacion] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalObligaciondoc, setObligaciondoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldoc, setModaldoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalfacturas, setModalfacturas] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const paginador = usePaginator();
    useEffect(() => {
        getListavdos();
    }, [paginador.page, tableName, idProject])
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    useEffect(() => {
        if (modalobligacion.view) {
            verDocObligacion();
        }
    }, [modalobligacion.view]);

    const head = [
        { title: 'Tipo Documento', property: 'Doc', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
        { title: 'Identificación', property: 'AccountNit', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
        { title: 'Estado', property: 'DocumentStateName', visible: true },
        { title: 'Pagos', property: 'DebtValue', visible: true, mask: MASK_MONEY },
        { title: 'Legalizaciones', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Unidad Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Obligación', property: 'OBDocumentName', visible: true },
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Obligación Presupuestal ', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalobligacion({ ...modalobligacion, "view": true }) } },
            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const getListavdos = () => {

        getinfo.instance.getDocumentsForProjectData(documentsTable, idProject, Account, mnemonic, consecutive, null, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);

                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Doc = (user.DataBeanProperties.Mnemonic ?? "") + "-" + (user.DataBeanProperties.Consecutive ?? "");

                    });
                    setLista(x)
                }
            }
        )

    }
    const verDocumentos = () => {

        if (getinfo.bean.IDDocument, getinfo.bean.DocumentDate) {
            _documentos.instance.getPdfAccountantDocument(getinfo.bean.IDDocument, null, getinfo.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModaldoc({ ...modaldoc, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const verDocObligacion = () => {

        if (getinfo.bean.OBIDDocument, getinfo.bean.OBDocumentDate) {
            _documentos.instance.getPdfAccountantDocument(getinfo.bean.OBIDDocument, null, getinfo.bean.OBDocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocsob(resp.DocumentURL);
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    return (
        <div className="row">
            <div className="col-md-6">
                <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} label="Tercero" />
            </div>
            <div className="col-md-6">
                <ProjectDataDocumentsType idSelector={mnemonic} onChange={(e) => { setmnemonic(e) }} documentsTable={documentsTable} idProject={idProject} />
            </div>
            <div className="col-md-6">
                <label>Búsqueda por Texto</label>
                <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
            </div>
            <div className="col-md-6">
                <label>Consecutivo de Documento</label>
                <input type="text" name="consecutive" className="form-control" value={consecutive} onChange={(e) => { setconsecutive(e.target.value) }} />
            </div>
            <div className="col-md-6 mt-4">
                <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getListavdos}>
                    Buscar
                </BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={getinfo.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <div className="row">
                    <div className="col-md-12">
                        <Modal modal={modaldoc} updateModal={setModaldoc}>
                            <div className="row">
                                <div className="row">
                                    <div className="col-md-12">
                                        <DocumentViewer
                                            list={docs}
                                            IDDocument={getinfo.bean.IDDocument}
                                            Since={getinfo.bean.DocumentDate}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <div className="col-md-12">
                            <Modal modal={modalobligacion} updateModal={setModalobligacion}>
                                <div className="row">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <DocumentViewer
                                                list={docsob}
                                                IDDocument={getinfo.bean.OBIDDocument}
                                                Since={getinfo.bean.OBDocumentDate}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}